import { render, staticRenderFns } from "./serveSupplier.vue?vue&type=template&id=67eb0a3a&"
import script from "./serveSupplier.vue?vue&type=script&lang=js&"
export * from "./serveSupplier.vue?vue&type=script&lang=js&"
import style0 from "./serveSupplier.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports